<h1 mat-dialog-title id="addEquipmentTitle" class="text-center">{{dialogTitle}}</h1>
<form class="example-form" id="form" [formGroup]="equipmentForm">
    <div class="row">
        <div class="col-6">
            <div *ngIf="!otherEquipmentName" class="relative w-full mb-3">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">
                    {{'MANAGEMENT_EQUIPMENT.EQUIPMENT_NAME' | translate }}
                </label>
                <mat-form-field>
                    <mat-select formControlName="title" placeholder="{{selectedOptionName}}">
                        <mat-option *ngFor="let equipment of equipmentNames" value="{{equipment}}">
                            {{equipment}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="otherEquipmentName" class="relative w-full mb-3">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="otherEquipmentName">
                    {{actionOtherEquipmentName}}
                </label>
                <mat-form-field>
                    <input matInput formControlName="otherEquipmentName" placeholder="Type Your Equipment Name Here" />
                </mat-form-field>
            </div>
        </div>
        <div class="col-6">
            <div *ngIf="!otherEquipmentType" class="relative w-full mb-3">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentType">
                    {{'MANAGEMENT_EQUIPMENT.EQUIPMENT_TYPE' | translate }}
                </label>
                <mat-form-field>
                    <mat-select formControlName="equipment_type" placeholder="{{selectedOptionType}}">
                        <mat-option *ngFor="let equipment of equipmentTypes" value="{{equipment}}">
                            {{equipment}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="otherEquipmentType" class="relative w-full mb-3">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="otherEquipmentService">
                    {{actionOtherEquipmentService}}
                </label>
                <mat-form-field>
                    <input matInput formControlName="otherEquipmentService" placeholder="Type Your Equipment Here" />
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-7">
                <div class="relative w-full mb-3">
                    <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="date">
                        {{'MANAGEMENT_EQUIPMENT.CHOOSE_DATE' | translate }}
                    </label>
                    <mat-form-field>
                        <input matInput formControlName="date" [matDatepicker]="picker">
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12">
        <div class="relative w-full mb-3">
            <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="description">
                {{'MANAGEMENT_EQUIPMENT.COMMENT' | translate }}
            </label>
            <mat-form-field class="example-full-width">
                <textarea matInput formControlName="description"></textarea>
            </mat-form-field>
        </div>
    </div>
</form>
<div id="buttons_group" class="mt-2 p-3 float-right">
    <div class="row">
        <div class="col-5">
            <button mat-raised-button mat-dialog-close="Close"
                style="background-color: red; color: white;">{{closeButton}}</button>
        </div>
        <div class="col-5">
            <button mat-raised-button mat-dialog-close style="background-color: #3fb56d; color: white;"
                (click)="addEquipment($event)">{{actionButton}}</button>
        </div>
    </div>
</div>
